import React, { Component } from 'react';
import Button from '../../components/Button';
import styles from './AssetsRename.module.css';
import propTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';
import { getJobResults, fetchRenameImages, upload } from '../../modules/jobs';
import Modal from 'react-modal';
import Checkbox from 'rc-checkbox';
import Divider from '../../components/Divider';

const replaceItem = [
  'Collection Code',
  'Item Code',
  'Material Code',
  'Leg Finish Code',
  'Arm Style Code',
  'Cushion Code',
];

Modal.setAppElement('#modal');

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    width: '500px',
    height: '80%',
    right: 'auto',
    bottom: 'auto',
    border: '1px solid grey',
    padding: '20px',
    borderRadius: 0,
    transform: 'translate(-50%, -50%)',
  },
};

class AssetsRename extends Component {
  state = {
    loading: false,
    displayNumber: 50,
    results: [],
    newResults: [],
    codes: {},
    newCodes: {},
    modalOpen: false,
    batches: [],
    selected: {},
  };

  static contextTypes = {
    router: propTypes.object,
  };

  navTo = (id, catogary) => {
    const { router } = this.context;
    const url = catogary ? `/${catogary}/${id}` : `/${id}`;
    const { history } = router;
    history.push(url);
  };

  onChange = e => {
    const id = e.target.id;
    const value = e.target.value;
    const { codes, newCodes } = this.state;
    if (id.indexOf('new') !== -1) {
      const key = id.replace(/\-new/gi, '');
      newCodes[key] = value;
    } else {
      codes[id] = value;
    }
    this.setState({ codes, newCodes });
    this.generateNewResults();
  };

  renameAndUpload = async () => {
    const { newCodes, codes, selected } = this.state;
    const { upload } = this.props;
    await upload({ newCodes, oldCodes: codes, selected });
    this.navTo('', 'renderings?page=0');
  };

  renderItemField = item => {
    return (
      <div className={styles.fieldContainer} key={item}>
        <div>
          <div className={styles.fieldTitle}> {item} </div>
          <input
            id={replaceItem.indexOf(item)}
            className={styles.inputField}
            onBlur={this.onChange}
          />
        </div>
        <div className={styles.separator}>></div>
        <div>
          <div className={styles.fieldTitle}>New {item} </div>
          <input
            id={`${replaceItem.indexOf(item)}-new`}
            className={styles.inputField}
            onBlur={this.onChange}
          />
        </div>
      </div>
    );
  };

  searchImage = async () => {
    const { fetchRenameImages } = this.props;
    const { codes } = this.state;
    const attrs = Object.keys(codes).reduce((acc, el) => {
      acc[replaceItem[el]] = codes[el];
      return acc;
    }, {});
    this.setState({ loading: true });
    const images = await fetchRenameImages(attrs);
    this.setState({
      results: images.results,
      loading: false,
      batches: images.batches,
      modalOpen: true,
    });
  };

  selectBatch = (e, id) => {
    let { selected, batches } = this.state;
    const checked = e.target.checked;
    if (checked) {
      if (id) {
        selected[id] = true;
      } else {
        for (let i in batches) {
          selected[batches[i]._id] = true;
        }
      }
    } else {
      if (id) {
        delete selected[id];
      } else {
        selected = {};
      }
    }
    this.setState({ selected });
  };

  componentDidUpdate(props, state) {
    if (
      state.results !== this.state.results ||
      state.displayNumber !== this.state.displayNumber
    ) {
      this.generateNewResults();
    }
  }

  generateNewResults = () => {
    const state = this.state;
    const newResults = [];
    const { results, displayNumber } = this.state;
    const filenames = results
      .slice(0, displayNumber)
      .map(item => item.split('/').pop());
    for (let i in filenames) {
      const codes = filenames[i]
        .replace(/item_|.png|.tff|.jpg/gi, '')
        .split('_');
      let hasMatch = false;
      for (let i = 0; i < 6; i++) {
        if (i === codes.length && state.newCodes[i]) {
          codes[i] = state.newCodes[i];
          hasMatch = true;
        } else if (i > codes.length && state.newCodes[i]) {
          codes[i - 1] = '0';
          codes[i] = state.newCodes[i];
          hasMatch = true;
        } else if (
          state.codes[i] &&
          state.newCodes[i] &&
          (!codes[i] || state.codes[i] === codes[i])
        ) {
          codes[i] = state.newCodes[i];
          hasMatch = true;
        }
      }
      if (hasMatch) {
        const newname = `item_${codes.join('_')}.png`;
        newResults.push(newname);
      }
    }
    this.setState({ newResults });
  };

  updateDisplayNumber = () => {
    const { displayNumber } = this.state;
    this.setState({ displayNumber: displayNumber + 50 });
  };

  setSelectedImages = () => {
    const { selected, results, batches } = this.state;
    if (Object.keys(selected).length === batches.length) {
      this.setState({ modalOpen: false });
      return;
    }
    for (let i in results) {
      const id = results[i].split('/')[3];
      if (!selected[id]) {
        results[i] = null;
      }
    }
    const newResults = results.filter(url => url);
    this.setState({ results: newResults, modalOpen: false });
  };

  displayBatch = batch => {
    const { selected } = this.state;
    return (
      <div className={styles.singleRowContainer}>
        <div className={styles.singleRow}>
          <Checkbox
            checked={selected[batch._id]}
            onChange={e => this.selectBatch(e, batch._id)}
            className={styles.rowCheck}
          />
          <div
            className={styles.batchTitle}
            onClick={() => window.open(`/renderings/${batch._id}`, '_blank')}
          >
            {batch.name}
          </div>
          <div className={styles.batchContent}> {batch.user}</div>
          <div className={styles.batchContent}>
            {moment(batch.createdAt).fromNow()}
          </div>
        </div>
      </div>
    );
  };

  render() {
    const {
      results,
      displayNumber,
      newResults,
      loading,
      modalOpen,
      batches,
    } = this.state;
    if (!results) return null;
    const imageTotal = results.length;
    const filenames = results
      .slice(0, displayNumber)
      .map(item => item.split('/').pop());
    return (
      <div className={styles.container}>
        <div className={styles.header}> Duplicate and Rename Assets </div>
        <div className={styles.titleContainer}>
          <div className={styles.title}>Replace</div>
          <div className={styles.title}>With</div>
          <div className={styles.btnContainer}>
            <Button text='Search' onClick={this.searchImage} />
            {loading && (
              <img className={styles.loadingIcon} src='/img/loading.svg' />
            )}
          </div>
        </div>
        <hr className={styles.divider} />
        {replaceItem.map(item => this.renderItemField(item))}
        <div className={styles.titleContainer}>
          <div className={styles.title}>Current Asset Filenames</div>
          <div className={styles.title}> New Asset Filenames</div>
        </div>
        <div className={styles.titleContainer}>
          <div className={styles.resultForm}>
            {filenames.map(item => (
              <div className={styles.resultName}>{item}</div>
            ))}
            {results.length > displayNumber && (
              <div
                className={styles.loadMore}
                onClick={this.updateDisplayNumber}
              >
                Load more results
              </div>
            )}
          </div>
          <div className={styles.resultForm}>
            {newResults.map(item => (
              <div className={styles.resultName}>{item}</div>
            ))}
          </div>
        </div>
        <div className={styles.titleContainer}>
          <div className={styles.imageStatistic}>{imageTotal} images found</div>
        </div>
        <div className={styles.buttonGroup}>
          <Button
            text='Perform Renames and Upoad to Scene7'
            onClick={this.renameAndUpload}
          />
          <span
            className={styles.cancelButton}
            onClick={() => this.navTo('', 'renderings')}
          >
            Cancel
          </span>
        </div>
        <Modal isOpen={modalOpen} style={customStyles}>
          <div className={styles.content}>
            <div
              className={styles.closeIcon}
              onClick={() => this.setState({ modalOpen: false })}
            />
            <div className={styles.modalHeader}>Renderings</div>
            <div className={styles.headerContainer}>
              <div className={styles.singleRow}>
                <Checkbox
                  className={styles.rowCheck}
                  onChange={e => this.selectBatch(e)}
                />
                <div className={styles.batchHeaderTitle}>Name</div>
                <div className={styles.batchHeaderTitle}>User</div>
                <div className={styles.batchHeaderTitle}>Created At</div>
              </div>
            </div>
            <Divider style={{ color: '#000' }} />
            {batches.map(batch => this.displayBatch(batch))}
            <div className={styles.modalBtnContainer}>
              <button
                className={styles.upload}
                onClick={this.setSelectedImages}
              >
                Select
              </button>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

const stateToProps = (state, router) => {
  const { id } = router.match.params;
  return {};
};

export default connect(stateToProps, {
  getJobResults,
  upload,
  fetchRenameImages,
})(AssetsRename);



// WEBPACK FOOTER //
// ./src/containers/AssetsRename/index.js